import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Button, Modal, ModalBody } from "react-bootstrap";
import "./WhyChooseSunwest.css";
import parse from "html-react-parser";
import useSunWestSuccessYears from '../Utils/useSunWestSuccessYears';
import SignUpForm from "../SignupForm/SignupForm";

export default function WhyChooseSunwest({ data }) {
  const [showForm, setShowForm] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailModal, setShowFailModal] = useState(false);
  const [validated, setValidated] = useState(false);

  const { whyChooseSunwestbox, title } = data?.whyChooseSunwest;
  const imgCDN = process.env.REACT_APP_CDN + "dscrheloc/images/";

  const successYears = useSunWestSuccessYears();
  const handleFailClose = () => {
    setShowFailModal(false);
    setValidated(false);
  };
  const handleSuccessClose = () => {
    setShowSuccessModal(false);
    setValidated(false);
  };

  const handleShowForm = () => {
    setShowForm(true);
  };
  const handleCloseForm = () => {
    setShowForm(false);
  };

  const handleContactUsClick = () => {
    setShowForm(true);
  };

  return (
    <>
      <div className="why-sunwest">
        <Container className="why-sunwest-container">
          <Row className="justify-content-center">
            <Col className="why-sunwest-title-col" xs={11} sm={9} md={9} lg={5}>
              <h3 className="why-swmc-title">{parse(title)}</h3>
            </Col>
            <Col className="why-sunwest-col" sm={12} md={12} lg={12}>
              {whyChooseSunwestbox && whyChooseSunwestbox.map((item, index) => (
                <div className="why-sunwest-item" key={item.id}>
                  <div className="why-sunwest-img-div">
                    <img
                      src={`${imgCDN}${item.whyChooseSunwestImg}`}

                      alt={index === 7 ? successYears + item.whyChooseSunwestTitle : parse(item.whyChooseSunwestTitle)}
                      className="why-sunwest-icon"
                    />
                    <h5> {index === 7 && successYears}{parse(item.whyChooseSunwestTitle)} </h5>
                  </div>
                  <p>{parse(item.whyChooseSunwestText)}</p>
                </div>
              ))}
            </Col>
          </Row>
          <button onClick={handleContactUsClick} className="real-story-btn">Begin Your Journey</button>
        </Container>
      </div>
      <Modal backdrop="static" centered show={showForm} onHide={handleCloseForm} size="lg">
        <Modal.Header closeButton onClick={handleCloseForm}>
          <Modal.Title>Please fill the information below to continue</Modal.Title>
        </Modal.Header>
        <ModalBody className='form-modal'>

          <SignUpForm closeForm={handleCloseForm} requestFromModal={true} setShowSuccessModal={setShowSuccessModal} setShowFailModal={setShowFailModal} />
        </ModalBody>
      </Modal>
      <Modal
        size="lg"
        centered
        show={showSuccessModal}
        onHide={handleSuccessClose}
        backdrop="static"
      >
        <Modal.Header closeButton />
        <Modal.Body className="text-center">
          <p className="thanktext m-4">Thank you for your interest. One of our representatives will contact you shortly. We look forward to serving you!</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleSuccessClose}>Close</Button>
        </Modal.Footer>
      </Modal>
      <Modal
        size="lg"
        centered
        show={showFailModal}
        onHide={handleFailClose}
        backdrop="static"
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <p className="thanktext">
            Due to technical difficulties your request could not be processed.
            Please contact us at&nbsp;
            <a href={"mailto:inquiry@swmc.com"} className="form-link">
              inquiry@swmc.com
            </a>
            .
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleFailClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
